import { PageHeader } from '@/shared/components';
import { WebhookEventLog } from '@/features/channex/webhook-event-log';

export function WebhookEventsPage() {
  return (
    <>
      <PageHeader
        eyebrow="System"
        title="Meldungen des"
        titleAccent="Kanalmanagers"
        description="Alles, was Channex an uns schickt, in der Reihenfolge des Eingangs. Die Fläche beantwortet eine Frage: Ist eine Buchung oder Änderung überhaupt angekommen — und wenn ja, warum ist daraus nichts geworden?"
      />
      <WebhookEventLog />
    </>
  );
}
